export default __webpack_public_path__ + "177ee1b9b29bca7a4fdb83f1b6f570b8.png";